module.exports = __webpack_public_path__ + "static/media/bathroom-floor-clean.a1a360d2.png";